export default "__VITE_ASSET__7b9db864__"